import { Button, CircularProgress, Grid, Typography } from "@material-ui/core";
import * as React from "react";
import { useState } from "react";
import { ErrorModal } from "../../../../../components/modals/error-modal";
import MesfModal from "../../../../../components/modals/modal.mesf";
import { useEmailTopicsContext } from "../../context/EmailTopicsContext";
import { deleteEmailTopic } from "../../repositories/EmailTopicsRepository";

type Props = {
	show: boolean;
	onHide: (shouldUpdate: boolean) => void;
};

export const DeleteEmailTopic = ({ show, onHide }: Props) => {
	const [isSubmitLoading, setIsSubmitLoading] = useState(false);
	const [error, setError] = useState("");
	const {
		state: { topicSelected },
	} = useEmailTopicsContext();

	const onDelete = async () => {
		if (!topicSelected) return;

		setIsSubmitLoading(true);
		try {
			await deleteEmailTopic(topicSelected.EmailTopicId);
			onHide(true);
		} catch (e: any) {
			setError(e?.message || "Error deleting email topic");
		} finally {
			setIsSubmitLoading(false);
		}
	};

	return (
		<>
			<ErrorModal error={error} onHide={() => setError("")} />
			<MesfModal
				title="DELETE EMAIL TOPIC"
				open={show}
				handleClose={() => onHide(false)}
				id="delete-email-topic-modal"
				maxWidth="sm"
			>
				<MesfModal.Content style={{ padding: "15px 30px 0" }}>
					<Typography>
						Delete <strong>{topicSelected?.EmailTopicName}</strong>? Nobody
						receives it any more, and its recipient list is lost.
					</Typography>
				</MesfModal.Content>
				<MesfModal.Actions>
					<Grid
						container
						spacing={2}
						justifyContent="flex-end"
						style={{ padding: "1rem" }}
					>
						<Grid item md={4} xs={12}>
							<Button
								fullWidth
								variant="contained"
								onClick={() => onHide(false)}
								disabled={isSubmitLoading}
							>
								CANCEL
							</Button>
						</Grid>
						<Grid item md={4} xs={12}>
							<Button
								fullWidth
								variant="contained"
								color="secondary"
								onClick={onDelete}
								disabled={isSubmitLoading}
							>
								{isSubmitLoading ? <CircularProgress size={24} /> : "DELETE"}
							</Button>
						</Grid>
					</Grid>
				</MesfModal.Actions>
			</MesfModal>
		</>
	);
};
